import { render } from "./servicecategory-list.vue?vue&type=template&id=154d922f&lang=html"
import script from "./servicecategory-list.vue?vue&type=script&lang=js"
export * from "./servicecategory-list.vue?vue&type=script&lang=js"

import "./servicecategory-list.vue?vue&type=style&index=0&id=154d922f&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__